import { useState, useEffect } from 'react';
import { Chat, ChatMessage } from '../types';
import { v4 as uuidv4 } from 'uuid';
import { getChatHistory, getChatMessages } from '../services/api';
import { useChat } from '../context/chatContext';

//const LAST_CHAT_ID_KEY = 'enantio-chat-id'

export const useChatHistory = (userId?: string) => {
  const [chats, setChats] = useState<Array<Chat>>([]);
  const [currentChat, setCurrentChat] = useState<{
    chat_id: string;
    total: number;
    start: number;
    end: number;
    messages: ChatMessage[];
  } | undefined>(undefined)
  const [activeChatId, setActiveChatId] = useState<string | null>(null);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const limit = 100;

  // In pages/src/hooks/useChatHistory.ts

const loadMoreChats = async (startOffset?: number) => {
  if (!userId) return;
  const effectiveOffset = startOffset ?? offset;
  if (!hasMore && startOffset === undefined) return;
  try {
    const data = await getChatHistory(userId, effectiveOffset, limit);
    const fetchedChats: Chat[] = data.chats || [];

    // MODIFICATION STARTS HERE
    setChats(prev => {
      // Create a Set of existing chat IDs for quick lookups.
      const existingChatIds = new Set(prev.map(chat => chat.id));
      
      // Filter out any fetched chats that already exist in the state.
      const uniqueNewChats = fetchedChats.filter(chat => !existingChatIds.has(chat.id));
      
      // Return the combined array of previous and unique new chats.
      return [...prev, ...uniqueNewChats];
    });
    // MODIFICATION ENDS HERE

    if (effectiveOffset === 0 && fetchedChats.length > 0) {
      //setActiveChatId(fetchedChats[0].id);
    }
    /* const savedChatId = localStorage.getItem(LAST_CHAT_ID_KEY)

    if(savedChatId) {
      //setActiveChatId(savedChatId)
    } */
    setOffset(effectiveOffset + fetchedChats.length);
    setHasMore(data.has_more);
  } catch (error) {
    console.error('Failed to load chats from server', error);
  }
};

  useEffect(() => {
    if (!userId) return;
    setChats([]);
    setActiveChatId(null);
    setOffset(0);
    setHasMore(true);
    loadMoreChats(0);
  }, [userId]);

  const createNewChat = () => {
    const newChat: Chat = { id: uuidv4(), title: 'New Chat', messages: [], created_at: new Date().valueOf(), updated_at: new Date().valueOf() };
    setChats(prev => [newChat, ...prev]);
    setActiveChatId(newChat.id);
    //localStorage.setItem(LAST_CHAT_ID_KEY, newChat.id)
    return newChat;
  };

  const addMessageToChat = (chatId: string, message: ChatMessage) => {
    setChats(prevChats =>
      prevChats.map(chat => {
        if (chat.id === chatId) {
          const title =
            chat.messages.length === 0 && message.sender === 'user'
              ? (message.text || '').slice(0, 16) || 'New Chat'
              : chat.title;
          return { ...chat, title, messages: [...chat.messages, message] };
        }
        return chat;
      })
    );
  };

  const removeChat = (chatId: string) => {
    setChats(prev => prev.filter(chat => chat.id !== chatId));
  };

  const updateChatTitle = (chatId: string, newTitle: string) => {
    setChats(prevChats =>
      prevChats.map(chat =>
        chat.id === chatId ? { ...chat, title: newTitle } : chat
      )
    );
  };

  const getActiveChat = () => chats.find(chat => chat.id === activeChatId);


  return {
    chats,
    activeChatId,
    setActiveChatId,
    createNewChat,
    addMessageToChat,
    updateChatTitle,
    getActiveChat,
    loadMoreChats,
    hasMore,
    removeChat,
  };
};
